module.exports = __webpack_public_path__ + "img/papas con chile y queso.5823b053.jpeg";